export default {"src":"/_next/static/media/Ihospital.ce28ef3b.svg","height":66,"width":65,"blurWidth":0,"blurHeight":0};